module.exports = __webpack_public_path__ + "static/media/ic_strategy_three.7a2f8ca9.svg";